"use state";

import { Box, Modal } from "@mui/material";
import useStashwiseStore from "@/hooks/useStashwiseStore";
import { useWidthResize } from "@/hooks/useWidth";
import { useEffect } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#ffffff",
  fontSize: "14px",
  outline: "none",
};

export default function ModalComponent({
  children,
  modalId,
  borderRadius = "2px",
}) {
  const { modals, setOpenModal } = useStashwiseStore();
  const { width } = useWidthResize();
  const isOpen = modals[modalId];

  //prevent the modal from having mobile view
  useEffect(() => {
    if (width > 768) setOpenModal(false);
  }, [width, setOpenModal]);

  return (
    <Modal open={isOpen} onClose={() => setOpenModal(modalId, false)}>
      <Box sx={{ ...style, borderRadius }}>{children}</Box>
    </Modal>
  );
}
